import React from 'react';
import RoundedModal from 'components/Global/RoundedModal/RoundedModal.jsx';
import ContentSplitModal from '../ContentSplitModal/ContentSplitModal.jsx';
import dataMap from './ModalDataMap.js';

const { insightsExport = {} } = dataMap;

const ComingSoonInsightsExportModal = ({ close, isOpen }) => (
  <RoundedModal close={close} isOpen={isOpen} title="Coming Soon">
    <ContentSplitModal
      onClick={close}
      isOpen={isOpen}
      title={insightsExport.title}
      content={insightsExport.content}
      image={insightsExport.image}
      imagePosition={insightsExport.imagePosition}
      btnText="Got It"
      modalTitle="Coming Soon"
    />
  </RoundedModal>
);

export default ComingSoonInsightsExportModal;
